/* KNM-92: composite endpoint, создаёт default RatePlan на год + рабочие периоды по месяцам. */
export type InitRatePlanReq = {
  start_date: string
  end_date: string
  min_nights: number
}

export type RatePlan = {
  id: number
  name: string
  parent: number | null
  is_default: boolean
  year: number
  start_date: string
  end_date: string
  min_nights: number
  discount: number | null
  discount_type: 'percent' | 'flat' | null
  room_categories: number[]
}

export type InitRatePlanRes = RatePlan

export const INIT_RATE_PLAN_URL = '/v2/pms/accomodations/:accomodation_id/rate_plans/init/'

/* KNM-92: GET всех RatePlan аккомодации. Поддерживает фильтры is_default, parent__isnull. */
export type GetRatePlansReq = {
  page?: number
  per_page?: number
  is_default?: boolean
  parent__isnull?: boolean
}

export type GetRatePlansRes = {
  count: number
  next: null | string
  previous: null | string
  total_pages: number
  results: RatePlan[]
}

export const GET_RATE_PLANS_URL = '/v2/pms/accomodations/:accomodation_id/rate_plans/'

/* KNM-92: PATCH default RatePlan (на сегодня меняется только min_nights через ЛК). */
export type UpdateRatePlanReq = Partial<{
  min_nights: number
  start_date: string
  end_date: string
  discount: number | null
  discount_type: 'percent' | 'flat' | null
  room_categories: number[]
}>

export type UpdateRatePlanRes = RatePlan

export const UPDATE_RATE_PLAN_URL = '/v2/pms/accomodations/:accomodation_id/rate_plans/:rate_plan_id/'
